<template>
  <create-contract-approval :ctype=0></create-contract-approval>
</template>

<script>
  import CreateContractApproval from './createContractApproval'
  export default {
    components: {
      CreateContractApproval,
    },

  };
</script>


// WEBPACK FOOTER //
// src/page/contract/CreateContractRecordApproval.vue